import React from 'react';
import { ProductCategoryList } from '../../Products/ProductCategoryList'

export const ProductCategory = props => {
  const { category } = props;
  return (
    <ProductCategoryList id={category} />
  );
};
